export const styles = {
  backdrop: {
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    inset: 0,
    // backgroundColor: "rgba(0, 0, 0, 0.6)",
    zIndex: -1,
  },
  cancelButton: {
    p: "10px 45px",
    lineHeight: "1.15",
    minWidth: 0,
    textTransform: "none",
    borderRadius: "50px",
    backgroundColor: "rgb(206, 28, 28)",
    border: `2px solid rgb(224, 86, 86)`,
    mt: 2,
    "&:hover": {
      backgroundColor: "rgb(206, 28, 28)",
    },
  },
  streakModal: {
    position: "absolute",
    // bottom: 80, //
    left: "50%",
    transform: "translateX(-50%)",
    m: 0,
    backgroundColor: "transparent",
    color: "white",
    borderRadius: "16px",
    padding: "8px 16px",
    minWidth: "250px",
    maxWidth: "90%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  coinImage: {
    animation: "smashLetsPlay 1.5s infinite",
    cursor: "pointer",
  },
  flippingCoin: {
    animation: "flipSmashCoin 3s ease-out forwards",
  },
}
